import { GET, POST, PATCH, DELETE } from "../config";

export const list = () => GET("shared/notifications/");
export const create = (data) => POST("shared/notifications/", data);
export const update = (id, data) => PATCH(`shared/notifications/${id}/`, data);
export const remove = (id) => DELETE(`shared/notifications/${id}/`);
export const getMyNotifications = () => GET("shared/notifications/my_notifications/");
